import React from 'react';
import { useGetServerInformationQuery } from 'generated/graphql';
import style from './style.module.css';

interface VersionTagProps {}

const VersionTag: React.FC<VersionTagProps> = () => {
  const { data, loading, error } = useGetServerInformationQuery();

  if (!data || loading || error) return null;

  return (
    <div className={style.tag}>
      {`UI: ${process.env.REACT_APP_VERSION || 'dev'}`}
      <br />
      {`API: ${(data.serverInformation && data.serverInformation.version) ||
        'unknown'}`}
    </div>
  );
};

export default VersionTag;
